import { render } from "./RegionAktobe.vue?vue&type=template&id=1dbeeeb1&ts=true"
import script from "./RegionAktobe.vue?vue&type=script&lang=ts"
export * from "./RegionAktobe.vue?vue&type=script&lang=ts"

import "./RegionAktobe.vue?vue&type=style&index=0&id=1dbeeeb1&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__